import { message } from 'antd';
import React, { useEffect } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { doCreateLicense } from '../../api/licenses';
import { LicenseI } from '../../interfaces/license';
import LicenseForm from '../../shared/components/forms/license/Form';

const LicenseNewPage: React.FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutate: createMutate, isLoading } = useMutation(doCreateLicense, {
    onSuccess: async () => {
      message.info('Create license successfully!');
      queryClient.invalidateQueries({
        queryKey: ['licenses', 'list'],
      });
      navigate(`/licenses`, { replace: true });
    },
    onError: () => {
      message.error('Create license failed! Please try again');
    },
  });

  const handleSubmit = async (values: LicenseI) => {
    createMutate(values);
  };

  useEffect(() => {
    localStorage.setItem('from', 'license-create');
  }, []);

  return (
    <div className="license-new-container">
      <div className="page-container">
        <div className="page-content">
          <div className="page-content-header">
            <h2 className="title-page">Add New License Sold</h2>
          </div>
          <LicenseForm handleSubmit={handleSubmit} isAPIRequestLoading={isLoading} />
        </div>
      </div>
    </div>
  );
};

export default LicenseNewPage;
